import type { GalleryLayout } from '../types/gallery-layout';

/**
 * Определяет CSS класс для фото в зависимости от его индекса и layout
 */
export function getPhotoClass(index: number, layout: GalleryLayout): string {
  if (index === 2 || index === 3) {
    return 'square';
  }

  if (layout === 'vertical-horizontal') {
    return index === 0 ? 'vertical' : 'horizontal';
  }

  if (layout === 'horizontal-horizontal') {
    return index === 0 ? 'horizontal' : 'square';
  }

  if (layout === 'vertical-vertical') {
    return index <= 1 ? 'vertical' : 'square';
  }

  return 'crop';
}
